export default {
	search: '엔터를 눌러 테마 검색',
	use: '테마 사용하기',
	used: '사용중인 테마',
};
